import styled from 'styled-components';
import colors from '../../../config/colors.json';
import ScreenSize from '../../../config/screenSizes.json';

export const ContentTitle = styled.h1`
  font-family: Poppins, Heltica, Arial, sans-serif;
  background-color: ${({ backgroundColor }) => (backgroundColor || colors.light)};
  font-size: ${({ fontSize }) => (fontSize || '2.5em')};
  color: ${({ color }) => (color || colors.darkGrey42)};
  font-weight: ${({ fontWeight }) => (fontWeight || '400')};
  line-height: ${({ lineheight }) => (lineheight || '45px')};
  padding: ${({ padding }) => (padding || '15px 27px')};
  margin-bottom: 0px;
  align-items: center;
  span {
      color: ${colors.red};
  }
  a, a:hover {
    text-decoration: none;
    color: inherit;
  }
  @media screen and (max-width: ${ScreenSize.portrait}px) {
   font-size: 20px;
  }
`;

export const ContentTitleBox = styled.h1`
  font-family: Poppins, Heltica, Arial, sans-serif;
  background-color: #000;
  color: ${colors.light};
  font-size: ${({ fontSize }) => (fontSize || '2.5em')};
  font-weight: 400;
  line-height: ${({ lineheight }) => (lineheight || '45px')};
  padding: ${({ padding }) => (padding || '15px 27px')};
  margin-bottom: 0px;
  align-items: center;
  span {
      color: ${colors.red};
  }
`;


export const ContentTitleBar = styled.div`
    font-family: Poppins, Heltica, Arial, sans-serif;
    display: flex;
    background-color: ${colors.light};
    justify-content: space-between;
    padding: 15px 27px;
`;

export const ContentTitleText = styled.div`
    font-family: Poppins, Heltica, Arial, sans-serif;
    font-size: 2.5em;
`;

export const ContentTitleButton = styled.button`
    border-radius: 4px;
    border: 1px solid ${colors.lightBlue};
    background-color: rgba(0,0,0,0);
    color: ${colors.lightBlue};
    font-size: 14px;
    min-width: 134px;
`;
